module.exports = __webpack_public_path__ + "static/media/1920x1080.79173b99.jpg";